import React from 'react';
import _ from 'lodash';

import './Spinner.css';

export default function Spinner(props) {
    const loadingText = !_.isEmpty(props.text) ? <div className="sk-folding-cube-text">{props.text}</div> : null;

    return (
        <div className={props.className}>
            <div className="sk-folding-cube" style={{ height: props.size, width: props.size }}>
                <div className="sk-cube1 sk-cube"></div>
                <div className="sk-cube2 sk-cube"></div>
                <div className="sk-cube4 sk-cube"></div>
                <div className="sk-cube3 sk-cube"></div>
            </div>
            {loadingText}
        </div>
    );
}
